import React, { useState } from "react";
import classNames from "classnames";
import { configApi } from "@shared/lib/configApi";
import { useCopyToClipboard } from "@shared/lib/hooks/useCopyToClipboard";
import { RouterConfig } from "@shared/lib/routerConfig";
import { CopyIcon } from "@shared/ui/Icon/ui/Common/CopyIcon";
import { compareShareTexts } from "./constants";
import { CompareShareProps } from "./types";
import classes from "./CompareShare.module.scss";

export const CompareShare = ({ compareId }: CompareShareProps) => {
    const compareLink = `${configApi.API_PUBLIC_DOMAIN}${RouterConfig.COMPARE}/${compareId}` ?? "";
    const [, copyUrlToClipboard] = useCopyToClipboard(compareLink);
    const [isCopied, setIsCopied] = useState(false);

    const textButton = isCopied ? compareShareTexts.COPIED_SUCCESS : compareShareTexts.BUTTON_TEXT;

    const handleCopyClick = () => {
        copyUrlToClipboard();
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 3000);
    };

    return (
        <button
            className={classes["compare-share"]}
            onClick={handleCopyClick}
            aria-label={compareShareTexts.ARIAL_LABEL}
        >
            <CopyIcon
                className={classNames(classes["compare-share__icon"], {
                    [classes["compare-share__icon--copied"]]: isCopied
                })}
            />
            <span
                className={classNames(classes["compare-share__text"], {
                    [classes["compare-share__text--copied"]]: isCopied
                })}
            >
                {textButton}
            </span>
        </button>
    );
};